export function appendQueryParameters(url = '', parameters = {}) {
    const queryParts = [];

    for (const [key, value] of Object.entries(parameters)) {
        if (Array.isArray(value)) {
            value.forEach((item, index) => {
                queryParts.push(`${encodeURIComponent(`${key}[${index}]`)}=${encodeURIComponent(item ?? '')}`);
            });
            continue;
        }

        queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value ?? '')}`);
    }

    if (queryParts.length === 0)
        return url;

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${queryParts.join('&')}`;
}
